var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalleryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBEDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1402 17.2657V22.6997C26.1402 24.713 24.8802 26.133 22.8668 26.133H17.1002C15.0868 26.133 13.8335 24.713 13.8335 22.6997V17.2657C13.8335 15.2523 15.0935 13.833 17.1002 13.833H22.8668C24.8802 13.833 26.1402 15.2523 26.1402 17.2657Z",
    stroke: "#130F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.521 22.9535L16.5397 21.8782C16.8937 21.5029 17.4837 21.4849 17.8597 21.8382C17.871 21.8495 18.4843 22.4729 18.4843 22.4729C18.8543 22.8495 19.459 22.8555 19.8357 22.4862C19.8603 22.4622 21.3917 20.6049 21.3917 20.6049C21.7863 20.1255 22.495 20.0569 22.975 20.4522C23.007 20.4789 24.4537 21.9635 24.4537 21.9635",
    stroke: "#130F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8753 18.0883C18.8753 18.7343 18.352 19.2576 17.706 19.2576C17.06 19.2576 16.5366 18.7343 16.5366 18.0883C16.5366 17.4423 17.06 16.9189 17.706 16.9189C18.352 16.9196 18.8753 17.4423 18.8753 18.0883Z",
    stroke: "#130F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/galleryIcon.ad1d450ba829902149f07ddbfe93db0e.svg";
export { ForwardRef as ReactComponent };